module.exports = __webpack_public_path__ + "static/media/dai.5b23e771.svg";